import { Injectable } from '@angular/core';
import {
  PropertySetsDialogActions,
  PropertySetsDialogActionsProps,
} from '../property-sets-dialog-actions/property-sets-dialog-actions';
import { PropertySetMode, PropertySetsState } from '../property-sets-dialog/property-sets-dialog';
import { of } from 'rxjs';

@Injectable()
export class PropertySetListDialogActionsService implements PropertySetsDialogActions<PropertySetsState> {
  private getTitle(state: PropertySetsState): string {
    return this._isPropertySetSelection(state) ? 'Add To Property Set' : 'My Property Sets';
  }

  private getSubtitle(state: PropertySetsState): string {
    const { ids = [], filters = {}, entity = '', source } = state;
    const [propertyType] = filters.property_types ?? [];
    const isPropertySetSelection = this._isPropertySetSelection(state);
    const entityArr = entity.split('');
    const entityTitleCase = `${entityArr[0]?.toUpperCase()}${entityArr.slice(1).join('')}`;

    const subtitle = `Select a Property Set below or click "New Property Set" to add ${ids.length} ${
      propertyType ?? ''
    } ${entityTitleCase} Record${ids.length === 1 ? '' : 's'}${
      source != null ? ` from the ${source}` : ''
    }, or create a new Property Set.`;
    return isPropertySetSelection ? subtitle : '';
  }

  private _isPropertySetSelection(state: PropertySetsState): boolean {
    const { ids, dialogMode } = state;
    return dialogMode === PropertySetMode.Manage && ids?.length > 0;
  }

  tickDialogProps(state: PropertySetsState): PropertySetsDialogActionsProps {
    return {
      title: this.getTitle(state),
      subtitle: this.getSubtitle(state),
      hasBackButton: false,
      showActions: false,
    };
  }

  handleSave() {
    // No implementation needed
    return of(true);
  }
  handleCancel(): void {
    // No implementation needed
  }
  handleBack(): void {
    // No implementation needed
  }
}
